import { configurationKeys } from '../constants/clientConstants';

export const getCaptchaProvider = (openIDConnectService) =>
  (
    openIDConnectService.getEsignetConfiguration(
      configurationKeys.captchaProvider
    ) ||
    process.env.REACT_APP_CAPTCHA_PROVIDER ||
    'legacy'
  )
    .trim()
    .toLowerCase();

const CAPTCHA_ALIASES = {
  'send-otp': ['send-otp', 'otp'],
  pwd: ['pwd', 'password'],
};

const captchaEnableList = (openIDConnectService) => {
  const raw = openIDConnectService.getEsignetConfiguration(
    configurationKeys.captchaEnableComponents
  );
  const value = raw ?? process.env.REACT_APP_CAPTCHA_ENABLE ?? '';
  return String(value)
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
};

export const isCaptchaEnabled = (openIDConnectService, component) => {
  const list = captchaEnableList(openIDConnectService);
  const wanted = CAPTCHA_ALIASES[component] || [component];
  return wanted.some((name) => list.includes(name));
};

export const getCaptchaSiteKey = (openIDConnectService) =>
  openIDConnectService.getEsignetConfiguration(
    configurationKeys.captchaSiteKey
  ) ?? process.env.REACT_APP_CAPTCHA_SITE_KEY;

/** @deprecated Challenge URL was used by ALTCHA; Turnstile uses site key only. */
export const getCaptchaChallengeUrl = () => '';
